import styled from "styled-components";

export const StyledHeader = styled.header`
  background-color: ${({ theme }) => theme.colors.header};
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    flex-direction: column;
  }
`;

export const Logo = styled.img`
  @media (max-width: ${({ theme }) => theme.mobile}) {
    margin-bottom: 40px;
  }
`;

export const Book = styled.h1`
  font-family: mmc-bold;
  color: white;
  margin: 0;
  padding-top: 40px;
  padding-left: 20px;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding-top: 300px;
  }
`;

export const Ready = styled.h1`
  font-family: "Fira Code", monospace;
  color: #a8a8a8;
  font-weight: 700;
  margin: 0;
  padding-top: 20px;
  text-align: center;
  font-size: 50px;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 35px;
  }
`;

export const Button = styled.a`
  display: flex;
  width: 200px;
  height: 50px;
  border: 2px solid white;
  background: linear-gradient(-60deg, #fff 50%, transparent 50%);
  cursor: pointer;
  background-size: 250% 100%;
  background-position: bottom left;
  transition: all 0.3s ease-out;
  text-decoration: none;
  margin: auto;

  &:hover {
    text-decoration: none;
    background-position: bottom right;
    color: black;
  }

  & > span {
    color: white;
    margin: auto;
    letter-spacing: 2px;
    font-family: mmc-bold;
    font-size: 20px;
  }

  & > span:hover {
    color: black;
  }
`;
